/* global */

export const DEMO_MODE = 'demo';
export const PRICES_CACHE_FILE = window.priceLoadDemoDevBuild
    ? 'http://module-price-load.local:8080/module-price-load/cache/price.json'
    : '/module-price-load/cache/price.json';

/* module attributes */

export const HOTEL_ATTRIBUTE = 'data-module-price-load-hotel-id';
export const ROOM_TYPE_ATTRIBUTE = 'data-module-price-load-room-type';
export const ADULTS_ATTRIBUTE = 'data-module-price-load-adults';
export const CURRENCY_ATTRIBUTE = 'data-module-price-load-currency';
export const DATE_ATTRIBUTE = 'data-module-price-load-date';
export const MIN_LOS_ATTRIBUTE = 'data-module-price-load-minlos';
export const OFFER_CODE_ATTRIBUTE = 'data-module-price-load-offer-code';
export const OFFER_NAME_ATTRIBUTE = 'data-module-price-load-offer-name';
export const LINK_ATTRIBUTE = 'data-module-price-load-link';
export const LINK_BOOK_URL_ATTRIBUTE = 'data-module-price-load-link-book-url';
export const RESTORE_STATUS_ATTRIBUTE = 'data-module-price-load-restore-status';
export const FILL_STATUS_ATTRIBUTE = 'data-module-price-load-fill-status';
export const EXTRA_PLACEMENT_PRICE_ATTRIBUTE = 'data-module-price-load-extra-placement-price';

/* local storage */

export const MODULE_NAME = 'module-price-load';
export const LOCAL_STORAGE_EXPIRE_ITEM = `${MODULE_NAME}:expire`;
export const LOCAL_STORAGE_PRICES_ITEM = `${MODULE_NAME}:prices`;
export const LOCAL_STORAGE_CACHE_VALUE = 30;
export const LOCAL_STORAGE_CACHE_MEASURE = 'minute';
export const LOCAL_STORAGE_EMPTY_CACHE = '';

// see cache measures here https://day.js.org/docs/en/manipulate/add

/* discount prices */

export const DISCOUNT_COOKIE_KEY = `${MODULE_NAME}_show_discount_prices`;

/* lang */

export const UNSUPPORTED_LANG = 'not-supported';
export const DEFAULT_LANG = 'en';
export const LANGUAGE_CODE_STANDARD_LENGTH = 2;

/* common */

export const DEFAULT_ARRAY_INDEX = 0;
export const DEFAULT_PRICE_DELIMITER = '.';
export const MULTI_ROOM_TYPE_DELIMITER = ',';
export const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY';
export const NON_BREAK_SPACE = '&nb[s]p';
export const PLACEHOLDER = {
    DateFormat: '{{DateFormat}}',
    MonthFormat: 'MMMM',
    MinLos: '{{minlos}}',
    MinLosEnd: '{{minlosDayEnd}}',
    MinLosDay: '{{minlosDay}}',
    Offer: '{{offer}}',
    Adults: '{{adults}}',
    AdultsEnd: '{{adultsEnd}}',
};
export const ROUND_OPTION = {
    No: false, // disable rounding
    RoundDown: 'RoundDown', // rounding down
    RoundUp: 'RoundUp', // rounding up
    RoundNearest: 'RoundNearest', // rounding to the nearest integer
};

/* link */

export const DEFAULT_BOOK_URL = `//${location.host}/booking/`;
export const LINK_PARAM_DELIMITER = ',';
